import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { OrderInterface } from '../../store/callrecorder/ordersSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.orderPath(value.id)
  };
}

export const ordersEntity = new schema.Entity(
  'orders',
  {},
  {
    processStrategy
  }
);

export const orderEntity = new schema.Entity(
  'order',
  {},
  {
    processStrategy
  }
);

const fetchOrdersCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      orders: { [key: string]: OrderInterface };
    }
  >(response.data.orders, [ordersEntity]);

  return {
    orders: normalized.entities?.orders || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { order: OrderInterface; }
  >(response.data.order, orderEntity);
  return normalized.entities;
}

export const fetchOrders = createAsyncThunk(
  `${PREFIX}_orders/fetchOrders`,
  async (params: object = {}) => fetchOrdersCollection('/onesky/orders', params)
);

export const fetchOrder = createAsyncThunk(
  `${PREFIX}_orders/fetchOrder`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/orders/${id}`);
    return normalizeInstance(response);
  }
);

export interface ReprocessMetaInterface {
  success: boolean;
  errors: string[];
}

export const reprocessOrder = createAsyncThunk(
  `${PREFIX}_orders/reprocessOrder`,
  async (id: number | string) => {
    const response = await callrecorderApi.post(`/onesky/orders/${id}/reprocess`);
    return {
      ...normalizeInstance(response),
      meta: response.data.meta as ReprocessMetaInterface
    };
  }
);

export const reprocessBundleOrders = createAsyncThunk(
  `${PREFIX}_orders/reprocessBundleOrders`,
  async (params: { bundle_id: number | string, status: 'pending' | 'failed' }) => {
    const response = await callrecorderApi.post('/onesky/orders/reprocess_all', params);
    return response.data as { queued_count: number };
  }
);
